import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoalSettingRoutingModule } from './goal-setting-routing.module';
import { GoalSettingHomeComponent } from './goal-setting-home/goal-setting-home.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '@app-shared/module/material/material.module';
import { NgOtpInputModule } from 'ng-otp-input';


@NgModule({
  declarations: [
    GoalSettingHomeComponent
  ],
  imports: [
    CommonModule,
    GoalSettingRoutingModule,
    NgbModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    NgOtpInputModule
  ]
})
export class GoalSettingModule { }
